import { AxiosInstance } from 'axios';
import { Report, ReportAdd, ReportDetails, ReportFilter, ReportTable } from 'models/api/report';
import ResTable from 'models/api/table';
import { Filter } from '@finbeat/react-toolkit';

const controller = '/reports';

export const getReportsList = async (axios: AxiosInstance, params?: ReportFilter) => {
    const response = await axios.get<ResTable<ReportTable>>(controller, {
        params: { ...params },
    });
    return response.data;
};

export const getReportsExcel = async (axios: AxiosInstance, params: ReportFilter) => {
    const { data } = await axios.get<Blob>(controller + '/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const addReport = async (axios: AxiosInstance, item: ReportAdd) =>
    await axios.post<Report>(controller + '', item);

export const reload = async (axios: AxiosInstance, id: number) =>
    await axios.get<Report>(controller + `/reload/${id}`);

export const getReport = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<Report>(controller + `/${id}`);
    return response.data;
};

export const getReportDetailsList = async (axios: AxiosInstance, id: number, params?: Filter) => {
    const response = await axios.get<ResTable<ReportDetails>>(controller + `/details/${id}`, {
        params: { ...params },
    });
    return response.data;
};

export const downloadReport = async (axios: AxiosInstance, id: number, params?: Filter) => {
    const response = await axios.get<Blob>(controller + `/detailsExcel/${id}`, {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return response;
};

export const downloadBalanceDetail = async (axios: AxiosInstance, ids: number[]) => {
    const response = await axios.get<Blob>(controller + `/balancedetailexcel`, {
        responseType: 'arraybuffer',
        params: { ids },
    });
    return response.data;
};
